module.exports = __webpack_public_path__ + "static/img/service_introduce_5876_zh.015c4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5876_zh.png
// module id = h4iU
// module chunks = 34